import { useEffect, useState } from "react";
import "../styles/FloatingWhatsApp.css";
import { PiWhatsappLogoThin } from "react-icons/pi";

export default function FloatingWhatsApp() {

  const phone = "919363966702";
  const message = "Hello! I want to know more about your products.";
  const whatsappLink = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;

  const [visible, setVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > lastScrollY) {
        // 🔽 scrolling down → hide
        setVisible(false);
      } else {
        // 🔼 scrolling up → show
        setVisible(true);
      }
      setLastScrollY(window.scrollY);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  return (
    <a
      href={whatsappLink}
      className={`whatsapp-float ${visible ? "show" : "hide"}`}
      target="_blank"
      rel="noreferrer"
    >
      <PiWhatsappLogoThin className="whatsapp-icon" />
    </a>
  );
}